/**
 * The ADP resolver reports never-collected as a GraphQL error, not an empty
 * payload. One predicate so the suppression and empty-state sites cannot drift.
 */
export function isAntennaNotFoundMessage(message: string): boolean {
  return /^Antenna '.+' not found$/.test(message);
}
